import React, { useEffect, useRef } from 'react';
import { FormControl, FormControlLabel, FormGroup, Checkbox, Typography, Autocomplete, TextField, Stack, Box, IconButton, Tooltip } from '@mui/material';
import { CssTextField, DivCard } from '../styles/styles';
import { Padding, PaletaColor } from '../styles/StylesConstantes';
import { AddOutlined, AlignHorizontalLeft, CheckBoxOutlineBlank, CheckBoxOutlined, DeleteOutline, DensityMedium, RadioButtonCheckedOutlined, RadioButtonUnchecked } from '@mui/icons-material';

const EncuestaFormComponents = ({
    setOptionsEncuesta, optionsEncuesta, handleEventEnter,
    handleRemovePregunta, handleAgregarCardNueva,
    errorOptionsLabelsValueIndexs, setErrorOptionsValueIndexs,
    errorOptionsValuesIndexs, setErrorOptionsValuesIndexs,
    errorOptionsLabelsEncuestaValueIndexs, setErrorOptionsLabelsEncuestaValueIndexs
}) => {

    const inputRefs = useRef([]); // Array de referencias para los campos de entrada

    const focusNextInput = (index) => {
        console.log('index', index);
        // Enfoca el siguiente campo de entrada si existe
        if (inputRefs.current[index + 1]) {
            inputRefs.current[index + 1].focus();
        }
    };


    const arrayOptions = [
        { id: 1, label: 'Selección unica', icon: RadioButtonCheckedOutlined, type: 'radio' },
        { id: 2, label: 'Casillas', icon: CheckBoxOutlined, type: 'checkbox' },
        { id: 3, label: 'Respuesta corta', icon: AlignHorizontalLeft, type: 'text' },
        { id: 4, label: 'Text múltiple', icon: DensityMedium, type: 'text-multiple' },
    ];

    const arrayOptionsAuxiliar = [
        { id: 1, label: 'Selección unica', type: 'radio' },
        { id: 2, label: 'Casillas', type: 'checkbox' },
        { id: 3, label: 'Respuesta corta', type: 'text' },
        { id: 4, label: 'Text múltiple', type: 'text-multiple' },
    ];



    return (
        <div style={{}}>
            {optionsEncuesta.length > 0 && (
                <div style={{}}>
                    {optionsEncuesta.map((option, index) => (
                        <div key={index} style={{ display: 'flex' }}>
                            <DivCard>
                                <Stack direction="row" spacing={2} style={{ marginTop: Padding.P3 }}>
                                    <div style={{ flex: 1 }}>
                                        <Typography variant={"body1"} style={{ marginTop: Padding.P2 }}>
                                            {option?.label}
                                        </Typography>

                                        <CssTextField
                                            variant="outlined"
                                            margin="normal"
                                            placeholder='Ingrese la pregunta'
                                            value={option?.value}
                                            onChange={(e) => {
                                                const newOptions = [...optionsEncuesta];
                                                newOptions[index].value = e.target.value;
                                                setOptionsEncuesta(newOptions);

                                                //remover el index si existe de errorOptionsLabelsValueIndexs
                                                const indexToRemove = errorOptionsLabelsValueIndexs.indexOf(index);
                                                if (indexToRemove !== -1) {
                                                    const newErrorOptionsLabelsValueIndexs = [...errorOptionsLabelsValueIndexs];
                                                    newErrorOptionsLabelsValueIndexs.splice(indexToRemove, 1);
                                                    setErrorOptionsValueIndexs(newErrorOptionsLabelsValueIndexs);
                                                }
                                            }}
                                            required
                                            fullWidth
                                            type={'text'}
                                            autoComplete="off"
                                            autoCapitalize={'off'}
                                            autoCorrect='off'
                                            error={errorOptionsLabelsValueIndexs.includes(index)}
                                            helperText={errorOptionsLabelsValueIndexs.includes(index) ? 'Campo requerido' : ''}
                                        />
                                    </div>


                                    <div style={{ flex: 1, marginTop: Padding.P2 }}>
                                        <Typography variant={'subtitle1'} style={{ marginBottom: Padding.P2 }}>
                                            Opciones
                                        </Typography>


                                        <Autocomplete
                                            disablePortal
                                            options={arrayOptions}
                                            // renderInput={(params) => <TextField {...params} label="Seleccione" />}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Seleccione"
                                                    error={errorOptionsValuesIndexs.includes(index)}
                                                    helperText={errorOptionsValuesIndexs.includes(index) ? 'Campo requerido' : ''}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        startAdornment: (
                                                            <>
                                                                {optionsEncuesta[index]?.selectorSelected && (
                                                                    // Renderiza el ícono directamente como JSX
                                                                    (() => {
                                                                        const selectedOption = arrayOptions.find(option => option.label === optionsEncuesta[index]?.selectorSelected);
                                                                        return selectedOption?.icon ? (
                                                                            <selectedOption.icon
                                                                                style={{ fontSize: 20, marginRight: 8, color: PaletaColor.COLOR_BACKGROUND_GRIS }}
                                                                            />
                                                                        ) : null;
                                                                    })()
                                                                )}
                                                                {params.InputProps.startAdornment}
                                                            </>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            value={arrayOptions.find(option => option.label === optionsEncuesta[index]?.selectorSelected) || null} // Encuentra el objeto que coincide
                                            isOptionEqualToValue={(option, value) => option.label === value.label} // Compara los valores

                                            onInputChange={(event, newInputValue) => {
                                                const newOptions = [...optionsEncuesta];
                                                newOptions[index].selectorSelected = newInputValue;

                                                // Encuentra el objeto correspondiente en arrayOptionsAuxiliar
                                                const selectedOption = arrayOptionsAuxiliar.find(option => option.label === newInputValue);

                                                // newOptions[index].options = selectedOption ? [selectedOption] : [];

                                                //se debe eliminar el resto de los objetos y dejar solo el de type === 'text'
                                                if (selectedOption?.type === 'text' && newOptions[index].options.length > 1) {
                                                    //agregar solo un objeto al array
                                                    newOptions[index].options = [{
                                                        id: 1,
                                                        label: 'Ingresar pregunta',
                                                        value: "",
                                                        type: 'text'
                                                    }]
                                                } else {

                                                    //agregar solo el type al objeto sin eliminar el resto de los objetos
                                                    newOptions[index].options = newOptions[index].options.map((optionItem) => {
                                                        return {
                                                            ...optionItem,
                                                            type: selectedOption?.type || 'radio', // Cambia el tipo según la selección
                                                        };
                                                    });
                                                }
                                                console.log('newInputValue', newOptions);
                                                newOptions[index].type = selectedOption?.type || 'radio'; // Cambia el tipo según la selección
                                                setOptionsEncuesta(newOptions);


                                                //remover el index si existe de errorOptionsValuesIndexs
                                                const indexToRemove = errorOptionsValuesIndexs.indexOf(index);
                                                if (indexToRemove !== -1) {
                                                    const newErrorOptionsValuesIndexs = [...errorOptionsValuesIndexs];
                                                    newErrorOptionsValuesIndexs.splice(indexToRemove, 1);
                                                    setErrorOptionsValuesIndexs(newErrorOptionsValuesIndexs);
                                                }
                                            }}

                                            renderOption={(props, option) => {
                                                const { key, ...optionProps } = props;
                                                return (
                                                    <Box
                                                        key={key}
                                                        component="li"
                                                        {...optionProps}
                                                    >
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    icon={<option.icon />}
                                                                    checkedIcon={<option.icon />}
                                                                />
                                                            }
                                                            label={option.label}
                                                            style={{
                                                                marginLeft: Padding.P2,
                                                                marginTop: Padding.P1,
                                                            }}
                                                        />
                                                    </Box>
                                                );
                                            }}
                                            loadingText="Cargando..."
                                            noOptionsText="No hay opciones"

                                        />
                                    </div>
                                </Stack>

                                {option?.options.map((optionItem, indexItem) => (
                                    <div key={indexItem} style={{ marginTop: Padding.P2 }}>
                                        <Stack direction="row" spacing={2} style={{ marginTop: Padding.P3, alignItems: 'center' }}>
                                            {optionItem?.type !== 'text' && (
                                                <>
                                                    {optionItem?.type === 'radio' && (
                                                        <RadioButtonUnchecked />
                                                    )}

                                                    {optionItem?.type === 'checkbox' && (
                                                        <CheckBoxOutlineBlank />
                                                    )}
                                                </>
                                            )}

                                            <CssTextField
                                                inputRef={(el) => (inputRefs.current[indexItem] = el)} // Asigna la referencia
                                                variant="standard"//outlined
                                                margin="normal"
                                                placeholder='Ingrese la respuesta'
                                                value={optionItem?.value || ''}
                                                //poner disabled si el selectorSelected === "Respuesta corta"
                                                disabled={option?.selectorSelected === 'Respuesta corta'}
                                                onChange={(e) => {
                                                    const newOptions = [...optionsEncuesta];
                                                    newOptions[index].options[indexItem].value = e.target.value;
                                                    setOptionsEncuesta(newOptions);

                                                    // Construir el índice en el formato '<index>-<indexItem>'
                                                    const indexToRemove = errorOptionsLabelsEncuestaValueIndexs.indexOf(`${index}-${indexItem}`);
                                                    if (indexToRemove !== -1) {
                                                        const newErrorOptionsLabelsEncuestaValueIndexs = [...errorOptionsLabelsEncuestaValueIndexs];
                                                        newErrorOptionsLabelsEncuestaValueIndexs.splice(indexToRemove, 1);
                                                        setErrorOptionsLabelsEncuestaValueIndexs(newErrorOptionsLabelsEncuestaValueIndexs);
                                                    }

                                                }}
                                                onKeyDown={(e) => {
                                                    console.log('e.key', e.key);
                                                    if (e.key === 'Enter') {
                                                        //si el selector esta en selectorSelected === "Respuesta corta" no se ejecuta el handleEventEnter
                                                        if (option?.selectorSelected === 'Respuesta corta') {
                                                            return;
                                                        }
                                                        handleEventEnter(e, index);
                                                        setTimeout(() => {
                                                            focusNextInput(indexItem);
                                                        }, 100); // Espera 100ms antes de enfocar el siguiente campo
                                                    }
                                                }}
                                                fullWidth
                                                type={'text'}
                                                autoComplete="off"
                                                autoCapitalize={'off'}
                                                autoCorrect='off'
                                                error={errorOptionsLabelsEncuestaValueIndexs.includes(`${index}-${indexItem}`)}
                                                helperText={errorOptionsLabelsEncuestaValueIndexs.includes(`${index}-${indexItem}`) ? 'Por favor complete esta opción' : ''}
                                            />


                                            {optionItem?.type !== 'text' && (
                                                <>
                                                    {option?.options.length > 1 && (
                                                        <IconButton aria-label="delete" onClick={() => {
                                                            const newOptions = [...optionsEncuesta];
                                                            newOptions[index].options.splice(indexItem, 1);
                                                            setOptionsEncuesta(newOptions);
                                                        }}>
                                                            <DeleteOutline />
                                                        </IconButton>
                                                    )}
                                                </>
                                            )}
                                        </Stack>
                                    </div>
                                ))}
                            </DivCard>


                            <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: PaletaColor.BLANCO, marginLeft: Padding.P2, borderRadius: Padding.P1, height: 100, marginTop: Padding.P5 }}>
                                {optionsEncuesta.length === 1 || optionsEncuesta.length - 1 === index ? (
                                    // Mostrar el botón "Agregar pregunta" solo en la última pregunta o si hay una sola pregunta
                                    <Tooltip title="Agregar pregunta" arrow>
                                        <IconButton aria-label="add" onClick={() => { handleAgregarCardNueva() }}>
                                            <AddOutlined />
                                        </IconButton>
                                    </Tooltip>
                                ) : (
                                    // Mostrar el botón "Eliminar" en las demás preguntas
                                    <Tooltip title="Eliminar pregunta" arrow>
                                        <IconButton aria-label="delete" onClick={() => { handleRemovePregunta(index) }}>
                                            <DeleteOutline />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}



        </div>
    );
};

export default EncuestaFormComponents;